
<!-- سمت چپ (ورود / خروج / ثبت‌نام) -->
<!-- <ul class="navbar-nav"> -->
<!-- <li class="nav-item" *ngIf="!isLoggedIn">
          <a class="nav-link" routerLink="/login">ورود</a>
        </li> -->
<!-- <li class="nav-item" *ngIf="!isLoggedIn">
          <a class="nav-link" routerLink="/register">ثبت‌ نام</a>
        </li> -->
<li class="nav-item" *ngIf="isLoggedIn">
    <a class="nav-link" (click)="logout()">خروج</a>
</li>
<!-- </ul> -->

<!-- قسمت ورود برای کاربران لاگین‌نشده -->
<!-- <form class="d-flex align-items-center" *ngIf="!isLoggedIn" (ngSubmit)="login()" style="gap: 5px;">
    <input type="text" class="form-control form-control-sm" placeholder="نام کاربری" [(ngModel)]="model.username"
        name="username" required style="width: 110px;">

    <input type="password" class="form-control form-control-sm" placeholder="رمز عبور" [(ngModel)]="model.password"
        name="password" required style="width: 110px;">

    <button class="btn btn-light btn-sm" type="submit">ورود</button>
    <a class="btn btn-light btn-sm" routerLink="/register">ثبت‌نام</a>

</form> -->

